import React from 'react';
import styles from './styles';
import {styleHandler} from '@xpertdox_js/xdcomponents';

const Message = props => {


  // compile message from arrays to <p>s
  // const renderMessage = msg => msg.map((content, i) => <p style={styles.paragraphLine}>{content}</p>)

  // style conditions
  const msgStyles = styleHandler([styles.message,
    props.from ? styles.messageFrom : styles.messageTo
  ])
  const contentStyles = styleHandler([styles.messageContent,
    props.from ? styles.contentFrom : styles.contentTo
  ])

  return(
    <div style={msgStyles}>

      {/* message header */}
      <div style={styles.messageHead}>
        <div style={styles.author}>
          {props.author && <span>{props.author}</span>}
        </div>
      </div>

      {/* message content */}
      <div style={contentStyles}>
        {/*props.content && renderMessage(props.content)*/}
        {props.content}
      </div>
      <div style={styles.timestamp}>
        {props.timestamp && <span>{props.timestamp}</span>}
      </div>
    </div>
  )
}

export default Message;
